<div
  class="4xl:px-[33vw] flex h-full w-full items-center justify-center bg-[#00344f] lg:px-[15vw] lg:py-[5vh] xl:px-[18vw] 2xl:px-[20vw]"
  [style.display.none]="!versionRetrieved()"
>
  <app-auth-bg-blobs></app-auth-bg-blobs>
  @if (dataLoaded().serverVersion && dataLoaded().clientVersion) {
    @if (!pwaUpdated()) {
      <div
        class="z-10 m-4 flex flex-col items-center space-y-8 rounded-3xl bg-[#004b70] p-8 text-white md:m-0 md:p-16"
      >
        @if (
          serverVersion() != ' ' && serverVersion() != '' && !!serverVersion()
        ) {
          <span class="w-full text-center text-2xl font-semibold">
            {{ 'Nuova versione disponibile' | siaTranslate }}
          </span>
          <button
            mat-raised-button
            color="primary"
            (click)="update()"
            class="update-button w-full"
          >
            <mat-icon>update</mat-icon>
            {{ 'Premi per aggiornare' | siaTranslate }}
          </button>
          <div
            class="flex w-1/3 flex-col items-center justify-center space-y-2 text-xs"
          >
            <div class="flex w-full justify-between">
              <span> Client </span>
              <span> {{ clientVersion() }}</span>
            </div>
            <div class="flex w-full justify-between">
              <span> Server </span>
              <span> {{ serverVersion() }}</span>
            </div>
          </div>
        } @else {
          <mat-icon class="!h-32 !w-32 !text-9xl">cloud_off</mat-icon>
          <span class="w-full text-center text-2xl font-semibold">
            {{ 'Nessuna connessione al server' | siaTranslate }}
          </span>
        }
      </div>
    } @else {
      <div
        class="z-10 flex h-fit max-h-[calc(100%-16px)] w-fit max-w-[calc(100%-16px)] flex-col items-center justify-center gap-2 rounded-3xl bg-[#004b70] p-2 text-white"
      >
        @if (
          serverVersion() != ' ' && serverVersion() != '' && !!serverVersion()
        ) {
          <div class="relative w-full">
            <div class="hidden h-16 items-center lg:flex lg:gap-2">
              <img src="assets/shared/framework-logo.png" class="h-16" />
            </div>
            <div class="absolute left-3 top-4 text-sm opacity-70 md:hidden">
              <ng-container
                [ngTemplateOutlet]="privacy"
                [ngTemplateOutletContext]="{ isMobile: true }"
              ></ng-container>
            </div>
            <span class="absolute right-3 top-4 text-sm opacity-70">
              v{{ serverVersion() }}
            </span>
          </div>

          <div
            class="flex flex-col items-center lg:flex-row lg:gap-[3vw] lg:px-[5vw] lg:py-0"
          >
            <img
              [src]="loginImage()"
              class="max-h-full w-[min(250px,70%)] bg-cover lg:w-[20vw]"
            />
            <div
              class="flex h-fit w-full flex-col items-center justify-center space-y-8 rounded-3xl lg:w-[20vw] lg:flex-row"
            >
              <router-outlet></router-outlet>
            </div>
          </div>

          <div
            class="flex h-fit w-full flex-nowrap items-end gap-4 px-1 lg:h-24"
            [class]="install() ? 'justify-start' : 'justify-between'"
          >
            <div
              class="hidden w-full flex-row items-start gap-2 text-sm md:flex md:w-fit md:items-center md:justify-start md:gap-4 md:space-y-0"
            >
              <ng-container
                [ngTemplateOutlet]="privacy"
                [ngTemplateOutletContext]="{ isMobile: false }"
              ></ng-container>
            </div>
            <div
              class="flex w-full flex-row items-center gap-2 md:flex-1 md:items-end md:justify-end md:gap-4"
            >
              <a
                href="https://siainformatica.com/"
                style="
                  color: white !important;
                  font-size: small;
                  text-decoration: none;
                "
                target="_blank"
                >powered by Sia Informatica</a
              >
              @if (!install()) {
                <button
                  (click)="installApp()"
                  mat-stroked-button
                  class="auth-install"
                >
                  <mat-icon> download </mat-icon>
                  Download app
                </button>
              }
            </div>
          </div>
        } @else {
          <mat-icon class="!h-32 !w-32 !text-9xl">cloud_off</mat-icon>
          <span class="w-full text-center text-2xl font-semibold">
            {{ 'Nessuna connessione al server' | siaTranslate }}
          </span>
        }
      </div>
    }
  }
</div>

<ng-template #privacy let-isMobile="isMobile">
  <a
    [routerLink]="'/privacy'"
    style="color: white !important"
    appI18n
    target="_blank"
  >
    {{ !isMobile ? 'Privacy policy' : 'Privacy' }}
  </a>
</ng-template>
